import { Outlet, useNavigate } from "react-router-dom";
import Header from "../components/ui/Header";
import { useAuth } from "../context/AuthContext";

const navItems = [
  { to: "/admin/upload", label: "Uploader" },
  { to: "/admin/payouts", label: "Payouts" },
  { to: "/admin/performance", label: "Performance" },
  { to: "/admin/products", label: "Products" },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  function handleLock() {
    logout();
    navigate("/login", { replace: true });
  }

  return (
    <div className="min-h-screen w-full bg-collectors-bg text-black font-sans overflow-x-hidden flex flex-col">
      <Header authenticated onLock={handleLock} navItems={navItems} />

      <main className="flex-grow flex flex-col items-center p-6 pt-32 md:pt-36 relative w-full max-w-[1600px] mx-auto">
        <Outlet />
      </main>
    </div>
  );
}